"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageType;
(function (MessageType) {
    MessageType["B2U"] = "B2U";
    MessageType["U2B"] = "U2B";
    MessageType["U2U"] = "U2U";
    MessageType["INSIGHT"] = "INSIGHT";
})(MessageType || (MessageType = {}));
exports.default = MessageType;
//# sourceMappingURL=MessageType.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/interfaces/MessageType.js
// module id = 386
// module chunks = 8